"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var moment = require("moment");
var models_1 = require("./models");
var engine_1 = require("./engine");
exports.calculateComparisonForGranularity = function (table, currentValue, comparison) {
    var comparedPoint;
    // index of the current value
    var idx = table.findIndex(function (value) { return value.timestamp.valueOf() === currentValue.timestamp.valueOf() && value.measure === currentValue.measure; });
    if (idx <= 0) {
        return undefined;
    }
    // if we're comparing just previous period, it's safe to show current vs previous mark
    if (!comparison ||
        (comparison.dateTrunc === comparison.compareTo && comparison.numberOfPeriods === 1 || comparison.dateTrunc === models_1.DateTrunc.UNKNOWN)) {
        comparedPoint = exports.calcuateComparisonByPoints(idx, 1, table);
    }
    else {
        // else we need to check for data for the date desired
        comparedPoint = exports.findComparisonValue(comparison, currentValue, table, idx);
        if (!comparedPoint) {
            // no value at the desired date; show no comparison
            return undefined;
        }
    }
    var previous = comparedPoint.measure;
    var absolute = currentValue.measure - previous;
    var percentage = absolute === 0 ? 0 : (absolute / previous);
    return {
        absolute: absolute,
        percentage: percentage,
        comparedPoint: comparedPoint,
    };
};
exports.generateComparisonLine = function (table, windowedTable, comparison) {
    var renderLine = [];
    var comparisonLine = [];
    windowedTable.forEach(function (point) {
        var metricComparison = exports.calculateComparisonForGranularity(table, point, comparison);
        if (metricComparison) {
            renderLine.push({
                measure: metricComparison.comparedPoint.measure,
                timestamp: point.timestamp
            });
            comparisonLine.push({
                measure: metricComparison.comparedPoint.measure,
                timestamp: metricComparison.comparedPoint.timestamp
            });
        }
    });
    var range = engine_1.getDateRange(comparisonLine);
    return {
        comparisonRange: range,
        comparisonPoints: renderLine,
    };
};
exports.momentStringFromDateTrunc = function (dateTrunc) {
    switch (dateTrunc) {
        case models_1.DateTrunc.SECOND: {
            return 'seconds';
        }
        case models_1.DateTrunc.MINUTE: {
            return 'minutes';
        }
        case models_1.DateTrunc.HOUR: {
            return 'hours';
        }
        case models_1.DateTrunc.ISO_WEEKDAY:
        case models_1.DateTrunc.DAY: {
            return 'days';
        }
        case models_1.DateTrunc.MONTH: {
            return 'months';
        }
        case models_1.DateTrunc.ISO_WEEK:
        case models_1.DateTrunc.WEEK: {
            return 'weeks';
        }
        case models_1.DateTrunc.ISO_QTR:
        case models_1.DateTrunc.QUARTER: {
            return 'quarters';
        }
        case models_1.DateTrunc.ISO_YEAR:
        case models_1.DateTrunc.YEAR: {
            return 'years';
        }
        default: {
            // compare to previous point
            return undefined;
        }
    }
};
exports.findTargetDate = function (amount, unit, currentDate, table) {
    currentDate.subtract(amount, unit);
    var comparisonIndex = table.findIndex(function (value) { return currentDate.isSame(value.timestamp); });
    if (comparisonIndex < 0) {
        return undefined;
    }
    return table[comparisonIndex];
};
exports.calcuateComparisonByPoints = function (currentIndex, amount, table) {
    return table[currentIndex - amount];
};
exports.findComparisonValue = function (comparison, currentValue, table, currentIndex) {
    var currentDate = moment.utc(currentValue.timestamp);
    var amount = exports.calculateTimeDifference(comparison);
    var unit = exports.momentStringFromDateTrunc(comparison.dateTrunc);
    if (!unit) {
        return exports.calcuateComparisonByPoints(currentIndex, amount, table); // just want 1 point away
    }
    return exports.findTargetDate(amount, unit, currentDate, table);
};
// calculate the amount of time units to subtract from the current point's date to the date we want to compare
exports.calculateTimeDifference = function (comparison) {
    switch (comparison.dateTrunc) {
        case models_1.DateTrunc.SECOND: {
            return mapSeconds(comparison.compareTo);
        }
        case models_1.DateTrunc.MINUTE: {
            return mapMinutes(comparison.compareTo);
        }
        case models_1.DateTrunc.HOUR: {
            return mapHours(comparison.compareTo);
        }
        case models_1.DateTrunc.ISO_WEEKDAY:
        case models_1.DateTrunc.DAY: {
            return mapDays(comparison.compareTo, comparison.numberOfPeriods);
        }
        case models_1.DateTrunc.MONTH: {
            return mapMonths(comparison.compareTo);
        }
        case models_1.DateTrunc.ISO_WEEK:
        case models_1.DateTrunc.WEEK: {
            return mapWeeks(comparison.compareTo, comparison.numberOfPeriods);
        }
        case models_1.DateTrunc.ISO_QTR:
        case models_1.DateTrunc.QUARTER: {
            return mapQuarters(comparison.compareTo);
        }
        case models_1.DateTrunc.NONE:
            // do nothing, don't compare to anything
            return 0;
        case models_1.DateTrunc.ISO_YEAR:
        case models_1.DateTrunc.YEAR:
        case models_1.DateTrunc.UNKNOWN:
        case undefined:
        default: {
            // compare to previous point
            return 1;
        }
    }
};
var mapSeconds = function (compareTo) {
    switch (compareTo) {
        case models_1.DateTrunc.SECOND:
            return 1;
        case models_1.DateTrunc.MINUTE:
            return 60;
        case models_1.DateTrunc.HOUR:
            return 3600;
        case models_1.DateTrunc.ISO_WEEKDAY:
        case models_1.DateTrunc.DAY:
            return 86400;
        case models_1.DateTrunc.ISO_WEEK:
        case models_1.DateTrunc.WEEK:
            return 604800;
        default:
            return 1;
    }
};
var mapMinutes = function (compareTo) {
    switch (compareTo) {
        case models_1.DateTrunc.MINUTE:
            return 1;
        case models_1.DateTrunc.HOUR:
            return 60;
        case models_1.DateTrunc.ISO_WEEKDAY:
        case models_1.DateTrunc.DAY:
            return 1440;
        case models_1.DateTrunc.ISO_WEEK:
        case models_1.DateTrunc.WEEK:
            return 10080;
        default:
            return 1;
    }
};
var mapDays = function (compareTo, numberOfPeriods) {
    switch (compareTo) {
        case models_1.DateTrunc.ISO_WEEKDAY:
        case models_1.DateTrunc.DAY:
            return 1;
        case models_1.DateTrunc.ISO_WEEK:
        case models_1.DateTrunc.WEEK:
            return 7 * numberOfPeriods;
        default:
            return 1;
    }
};
var mapHours = function (compareTo) {
    switch (compareTo) {
        case models_1.DateTrunc.HOUR:
            return 1;
        case models_1.DateTrunc.ISO_WEEKDAY:
        case models_1.DateTrunc.DAY:
            return 24;
        case models_1.DateTrunc.ISO_WEEK:
        case models_1.DateTrunc.WEEK:
            return 168;
        default:
            return 1;
    }
};
var mapWeeks = function (compareTo, numberOfPeriods) {
    switch (compareTo) {
        case models_1.DateTrunc.ISO_WEEK:
        case models_1.DateTrunc.WEEK:
            return numberOfPeriods;
        default:
            return 1;
    }
};
var mapMonths = function (compareTo) {
    switch (compareTo) {
        case models_1.DateTrunc.MONTH:
            return 1;
        case models_1.DateTrunc.ISO_YEAR:
        case models_1.DateTrunc.YEAR:
            return 12;
        default:
            return 1;
    }
};
var mapQuarters = function (compareTo) {
    switch (compareTo) {
        case models_1.DateTrunc.ISO_QTR:
        case models_1.DateTrunc.QUARTER:
            return 1;
        case models_1.DateTrunc.ISO_YEAR:
        case models_1.DateTrunc.YEAR:
            return 4;
        default:
            return 1;
    }
};
exports.calculateDataPointsWithComparison = function (data, comparison) {
    if (!comparison) {
        return data;
    }
    // The current index in the comparison array.
    // Since the data is sorted, we can walk the array down to keep up with 'data'.
    var comparisonIndex = 0;
    return data.map(function (dp) {
        while (comparisonIndex < comparison.length && comparison[comparisonIndex].timestamp < dp.timestamp) {
            comparisonIndex++;
        }
        var comparisonValue;
        if (comparisonIndex < comparison.length &&
            comparison[comparisonIndex].timestamp.getTime() === dp.timestamp.getTime()) {
            comparisonValue = comparison[comparisonIndex].measure;
        }
        return {
            measure: dp.measure,
            timestamp: dp.timestamp,
            comparison: comparisonValue,
        };
    });
};
//# sourceMappingURL=comparisonEngine.js.map